import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CallConfirm from '../CallConfirm/CallConfirm';
import ExitConfirm from '../ExitConfirm/ExitConfirm';
import Chat from '../Chat/Chat';
import PreChat from '../PreChat/PreChat';
import { setPage } from '../../redux/actions/commonActions';
import { getUrlParam, getUrlElement } from '../../utils/common';

export const Frame = () => {
    const { common, ui } = useSelector(state => state);
    const config = ui?.config?.attributes;
    const dispatch = useDispatch();

    const [stylePath, setStylePath] = useState('/css/dafabet.css');

    useEffect(() => {
        let brand = getUrlElement(6);
        if (brand === "mc-desktop") {
            brand = "dafabet";
        }
        setStylePath('/css/' + brand + '.css');
    }, [config]);

    useEffect(() => {
        const head = document.head;
        const link = document.createElement("link");

        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = stylePath;

        head.appendChild(link);

        return () => { head.removeChild(link); };
    }, [stylePath]);

    const showOverlay = common?.common?.page === 'exit-confirm' || common?.common?.page === 'call-confirm';

    return (
        <>
            {/* Overlay for popups */}
            {showOverlay && (
                <div className="overlay">
                    {common?.common?.page === 'exit-confirm' && <ExitConfirm />}
                    {common?.common?.page === 'call-confirm' && <CallConfirm />}
                </div>
            )}

            <div style={{ display: common?.common?.page !== 'pre-chat' ? 'contents' : 'none' }}>
                <Chat />
            </div>

            <div style={{ display: common?.common?.page === 'pre-chat' ? 'block' : 'none' }}>
                <PreChat />
            </div>
        </>
    );
};

export default Frame;
